import React, { useState, useEffect } from 'react';
import { projectFirestore, timestamp } from '../firebase/config';
import { CLOUDINARY_UPLOAD_PRESET, CLOUDINARY_UPLOAD_URL } from '../cloudinary/config';
import useSections from '../hooks/useSections';

const CoverManager = () => {
    const { sections: allSections } = useSections();
    const SECTIONS = allSections.filter(s => s.enabled !== false && s.key !== 'images');
    const [covers, setCovers] = useState({});
    const [uploading, setUploading] = useState({});
    const [progress, setProgress] = useState({});

    // استماع لتغييرات الأغلفة من Firestore
    useEffect(() => {
        const unsub = projectFirestore.collection('covers')
            .onSnapshot((snap) => {
                const data = {};
                snap.forEach(doc => {
                    data[doc.id] = doc.data();
                });
                setCovers(data);
            });
        return () => unsub();
    }, []);

    const handleUpload = (sectionKey, e) => {
        const file = e.target.files[0];
        if (!file) return;

        const fileType = ['image/jpeg', 'image/png', 'image/webp'];
        if (!fileType.includes(file.type)) {
            alert('برجاء اختيار صورة من نوع (png/jpeg/webp)');
            return;
        }

        setUploading(prev => ({ ...prev, [sectionKey]: true }));
        setProgress(prev => ({ ...prev, [sectionKey]: 0 }));

        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
        formData.append('folder', 'covers');
        formData.append('public_id', sectionKey);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', CLOUDINARY_UPLOAD_URL);

        xhr.upload.onprogress = (ev) => {
            if (ev.lengthComputable) {
                const perc = (ev.loaded / ev.total) * 100;
                setProgress(prev => ({ ...prev, [sectionKey]: perc }));
            }
        };

        xhr.onload = () => {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                const urlPath = response.secure_url;
                const createdAt = timestamp();
                const docRef = projectFirestore.collection('covers').doc(sectionKey);
                docRef.set({ url: urlPath, sectionKey, createdAt }).then(() => {
                    setUploading(prev => ({ ...prev, [sectionKey]: false }));
                }).catch((err) => {
                    console.error('Firestore error:', err);
                    setUploading(prev => ({ ...prev, [sectionKey]: false }));
                    alert('تم رفع الصورة لكن حدث خطأ في الحفظ: ' + err.message);
                });
            } else {
                console.error('Cloudinary error:', xhr.responseText);
                setUploading(prev => ({ ...prev, [sectionKey]: false }));
                alert('حدث خطأ أثناء رفع الصورة');
            }
        };

        xhr.onerror = () => {
            setUploading(prev => ({ ...prev, [sectionKey]: false }));
            alert('حدث خطأ في الاتصال');
        };

        xhr.send(formData);
    };

    return (
        <div className="container my-4">
            <h3 className="text-center mb-4">إدارة أغلفة الأقسام</h3>
            <div className="row g-3">
                {SECTIONS.map((section) => {
                    const coverUrl = covers[section.key]?.url || section.defaultCover || '';
                    const isUploading = uploading[section.key];
                    const prog = progress[section.key] || 0;

                    return (
                        <div className="col-md-4 col-sm-6" key={section.key}>
                            <div className="card shadow-sm h-100">
                                <div style={{ height: 180, overflow: 'hidden', background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {coverUrl ? (
                                        <img
                                            src={coverUrl}
                                            alt={section.label}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <span style={{ color: '#999' }}>لا يوجد غلاف</span>
                                    )}
                                </div>
                                <div className="card-body text-center">
                                    <h6 className="card-title">{section.label}</h6>
                                    {isUploading && (
                                        <div className="progress mb-2" style={{ height: 5 }}>
                                            <div
                                                className="progress-bar progress-bar-striped bg-info"
                                                style={{ width: prog + '%' }}
                                            />
                                        </div>
                                    )}
                                    <label className="btn btn-sm btn-outline-primary w-100">
                                        {covers[section.key] ? 'تغيير الغلاف' : 'إضافة غلاف'}
                                        <input
                                            type="file"
                                            accept="image/jpeg,image/png,image/webp"
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleUpload(section.key, e)}
                                            disabled={isUploading}
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CoverManager;
